import React from 'react';
import EventTemplateSchedulerContainer from '../../../Containers/AdminContainer/EventTemplateScheduler';

const EventTemplateSchedulerScreen = () => {
  return <EventTemplateSchedulerContainer />;
};

export default EventTemplateSchedulerScreen;
